import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { UserinfoWrapper } from "./UserDetails.styled";
import { Row, Col, Button, Popconfirm, Switch, Checkbox, SuccessNotification } from "components/common";
import { getUserPermissions } from "utils/text";
import { callGetApiWithAuth, callPostApi, callPutApi } from "utils/api";
import Avatar from "../../assets/svg/boy-avatar.svg";
import { MdEdit, MdLocationPin } from "react-icons/md";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { saveStorage } from "utils/auth";
import { Select, Upload } from "antd";

const { Option } = Select;

const UserInfo = ({
  id,
  data,
  accessLevel,
  location,
  getUserDetail,
}) => {
  const history = useHistory();
  const [repCom, setRepCom] = useState([]);
  const [postSetterCom, setpostSetterCom] = useState("");
  const [postRepCom, setpostRepCom] = useState("");
  const [postLocation, setPostLocation] = useState("");
  const [postAccessLevel, setPostAccessLevel] = useState("");
  const [isActive, setIsActive] = useState();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [sitPayAmount, setSitPayAmount] = useState("");
  const [kwPay, setKwPay] = useState("");
  const [overRide, setOverRide] = useState("");
  const [redline, setRedline] = useState("");
  const [isResetLoading, setIsResetLoading] = useState(false);
  const [check, setCheck] = useState(data?.companyCommission);
  const [availabilty, setAvailabilty] = useState(data?.available);
  const [companyAmount, setCompanyAmount] = useState("");
  const [showDisable, setShowDisable] = useState(!data?.companyCommission);
  const [perSit, setPerSitAmount] = useState("");
  const [isReferrals, setIsReferrer] = useState([]);
  const [profilePicture, setProfilePicture] = useState('');

  const [isEditKwCompany, setIsEditKwCompany] = useState(false);
  const [isEditSitPayAmount, setIsEditSitPayAmount] = useState(false);
  const [isEditKwPay, setIsEditKwPay] = useState(false);
  const [isEditManagerOverride, setIsEditManagerOverride] = useState(false);
  const [isEditPerSetterAmount, setIsEditPerSetterAmount] = useState(false);
  const [isEditPerSitAmount, setIsEditPerSitAmount] = useState(false);
  const [isEditCompanyCommissionAmount, setIsEditCompanyCommissionAmount] = useState(false);

  let ReferralsCount = isReferrals?.length;

  let values = accessLevel?.filter((el) => String(el?._id) === data?.roleId)[0]
    ?.role;
  let locationText = location?.filter((el) => String(el?._id) == data?.locationId)?.[0];

  const handelPictureUpload = (file) => {
    if (file) {
      callPostImageApi(file);
      setProfilePicture(URL.createObjectURL(file));
    }
  }
  const UserUpdateHandler = (changes) => {
    callPutApi(`/user/${id}`, changes, (data) => {
      SuccessNotification("Data Successfully Updated");
      setIsDeleteLoading(false);
      getUserDetail();
      setIsEditKwCompany(false)
      setIsEditSitPayAmount(false)
      setIsEditKwPay(false)
      setIsEditManagerOverride(false)
      setIsEditPerSitAmount(false)
    }, (err) => { setIsDeleteLoading(false); })
  }
  const postResetPassword = () => {
    setIsResetLoading(true);
    callPostApi(
      `/auth/reset-password/${id}`,
      null,
      (data) => {
        SuccessNotification("Password Reset Link sent");
        setIsResetLoading(false);
      },
      (err) => {
        console.log(err);
        setIsResetLoading(false);
      }
    );
  };
  const postAccessApi = (e) => {
    setPostAccessLevel(e);
    let formData = {
      roleId: e,
    };
    UserUpdateHandler(formData)
  };
  const postActiveApi = () => {
    setIsDeleteLoading(true);

    setIsActive(!isActive);
    let formData = {
      active: !isActive,
    };
    UserUpdateHandler(formData)
  };
  const postLocationApi = (e) => {
    setPostLocation(e);
    let formData = {
      locationId: e,
    };
    UserUpdateHandler(formData)
  };
  const postEditKwApi = () => {
    let formData = {
      kwPay: kwPay,
    };
    UserUpdateHandler(formData)
  };
  const postEditSitApi = () => {
    let formData = {
      sitPayAmount: sitPayAmount,
    };
    UserUpdateHandler(formData)
  };
  const postEditPerSitApi = () => {
    let formData = {
      perSit: perSit,
    };
    UserUpdateHandler(formData)
  };
  const postOverrideApi = () => {
    let formData = {
      overRide: overRide,
    };
    UserUpdateHandler(formData)
  };
  const postSetterApi = (e) => {
    setpostSetterCom(e);
    let formData = {
      repWithSetterCommissionTier: e,
    };
    UserUpdateHandler(formData)
  };
  const postRepApi = (e) => {
    setpostRepCom(e);
    let formData = {
      repCloserCommissionTier: e,
    };
    UserUpdateHandler(formData)
  };
  const postPerSitAmount = () => {
    let formData = {
      perSitAmount: perSit,
    };
    UserUpdateHandler(formData)
  };
  const postEditRedLineApi = () => {
    let formData = {
      redline: redline
    };
    UserUpdateHandler(formData)
  };
  const postAvailiblityApi = () => {
    setAvailabilty(!availabilty)
    let formData = {
      available: !availabilty
    };
    UserUpdateHandler(formData)
  };
  const RepComTiers = () => {
    callGetApiWithAuth(
      "/repcommission",
      (data) => {
        setRepCom(data);
      },
      (err) => { }
    );
  };
  const postCompanyCheckApi = (e) => {
    setCheck(e.target.checked);
    setShowDisable(check);
    let formData = {
      companyCommission: e.target.checked,
    };
    UserUpdateHandler(formData)
  };
  const postCompanyKwApi = () => {
    let formData = {
      companyKW: companyAmount,
    };
    UserUpdateHandler(formData)
  };
  const postCompanyAmountApi = () => {
    let formData = {
      companyKW: companyAmount,
    };
    UserUpdateHandler(formData)
  };
  const handleLoginAsUser = (email, password) => {
    callPostApi("/auth/login/user/new/session", { email, password }, (data) => {
      SuccessNotification("Login Successful");
      saveStorage(data);
      history.push("/");
    }, (err) => {
      console.log(err);
    });
  };
  const callPostImageApi = (file) => {
    const formData_ = new FormData();
    formData_.append("file", file);
    callPutApi(`/user/profile/picture/${id}`, formData_, (data) => {
      SuccessNotification("Profile Updated Successfully");
    }, (err) => { console.log(err); });
  };

  useEffect(() => {
    RepComTiers();
  }, []);
  useEffect(() => {
    if (data) {
      setPostLocation(data?.locationId);
      setpostSetterCom(data?.repWithSetterCommissionTier);
      setpostRepCom(data?.repCloserCommissionTier);
      setPostAccessLevel(data?.roleId);
      setIsActive(data?.active);
      setSitPayAmount(data?.sitPayAmount);
      setKwPay(data?.kwPay);
      setRedline(data?.redline);
      setOverRide(data?.override);
      setShowDisable(!data?.companyCommission);
      setCheck(data?.companyCommission);
      setCompanyAmount(data?.companyKW);
      setPerSitAmount(data?.perSitAmount);
      setIsReferrer(data?.referrals);
      setProfilePicture(data?.profilePicture || Avatar);
    }
  }, [
    data?.locationId,
    data?.accessLevel,
    data?.companyCommission,
    ReferralsCount,
  ]);

  return (
    <UserinfoWrapper profile={data?.profilePicture ? true : false}>
      <div className="top-container">
        <div className="image-container">
          <img src={profilePicture} alt="User Image" className="image" />
          <div className="edit-icon-container">
            <Upload name="image" accept="image/*" beforeUpload={() => false} onChange={(info) => handelPictureUpload(info.file)} showUploadList={false}>
              <MdEdit color="white" className="edit-icon" />
            </Upload>
          </div>
        </div>
      </div>
      <div className="content-container">
        <div className="content-display">
          <div className="title">{data?.username}</div>
          <div className="subtitle">
            <MdLocationPin size={14} /> {locationText?.name}, {locationText?.state}
          </div>
        </div>
        <Row gutter={[30, 30]} className="fields-container">
          {/* Email */}
          <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
            <div className="card-box">
              <div className="title">Email:</div>
              <div className="field">
                <div className="text">{data?.email}</div>
              </div>
            </div>
          </Col>
          {/* Access Level */}
          <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
            <div className="card-box">
              <div className="title">Access Level:</div>
              <div className="field">
                {getUserPermissions("edit-user-access-level-action") ? (
                  <Select value={postAccessLevel} className="select" onChange={postAccessApi}>
                    {accessLevel.map((access) => (
                      <Option key={access._id} value={access._id}>{access.role}</Option>
                    ))}
                  </Select>
                ) : (
                  <div className="text">{accessLevel?.filter((el) => el?.id == data?.accessLevel)[0]?.role}</div>
                )}
              </div>
            </div>
          </Col>
          {/* Location */}
          <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
            <div className="card-box">
              <div className="title">Location:</div>
              <div className="field">
                {getUserPermissions("edit-user-location-action") ? (
                  <Select value={postLocation} className="select" onChange={postLocationApi}>
                    {location.map((loc) => (
                      <Option key={loc._id} value={loc._id}>{loc.name}, {loc.state}</Option>
                    ))}
                  </Select>
                ) : (
                  <div className="text">{locationText?.name}, {locationText?.state}</div>
                )}

              </div>
            </div>
          </Col>
          {/* Availabilty */}
          <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
            <div className="card-box">
              <div className="title">Availabilty:</div>
              <div className="field">
                <div className="switch">
                  <Switch checked={availabilty} checkedChildren="Yes" unCheckedChildren="No" onChange={postAvailiblityApi} />
                </div>
              </div>
            </div>
          </Col>
          {/* Active */}
          <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
            <div className="card-box">
              <div className="title">Activity:</div>
              <div className="field">
                <div className="switch">
                  <Switch checked={isActive} checkedChildren="Active" unCheckedChildren="InActive" onChange={postActiveApi} />
                </div>
              </div>
            </div>
          </Col>
          {/* KW Company */}
          <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
            <div className="card-box">
              <div className="title">Company Kw:</div>
              <div className="field">
                {isEditKwCompany ? (
                  <div className="edit">
                    <input type="text" value={companyAmount} onChange={(e) => setCompanyAmount(e.target.value)} className="input" />
                    <div className="save">
                      <AiFillCheckCircle cursor="pointer" size={16} onClick={postCompanyKwApi} />
                      <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditKwCompany(false)} />
                    </div>
                  </div>
                ) : (
                  <div className="text">
                    {companyAmount}
                    <MdEdit color="black" className="edit-icon" onClick={() => setIsEditKwCompany(true)} cursor="pointer" />
                  </div>
                )}
              </div>
            </div>
          </Col>
          {/* sit pay amount, kw pay */}
          {values === "Setter" && (
            <>
              {/* Sit Pay Amount */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Sit Pay Amount:</div>
                  <div className="field">
                    {getUserPermissions("edit-sit-pay-amount-action") ? (
                      <>
                        {isEditSitPayAmount ? (
                          <div className="edit">
                            <input type="text" value={sitPayAmount} onChange={(e) => setSitPayAmount(e.target.value)} className="input" />
                            <div className="save">
                              <AiFillCheckCircle cursor="pointer" size={16} onClick={postEditSitApi} />
                              <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditSitPayAmount(false)} />
                            </div>
                          </div>
                        ) : (
                          <div className="text">
                            {sitPayAmount}
                            <MdEdit color="black" className="edit-icon" onClick={() => setIsEditSitPayAmount(true)} cursor="pointer" />
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text">
                        {sitPayAmount}
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              {/* kw Pay Amount */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Kw Pay:</div>
                  <div className="field">
                    {getUserPermissions("edit-user-kw-pay-action") ? (
                      <>
                        {isEditKwPay ? (
                          <div className="edit">
                            <input type="text" value={kwPay} onChange={(e) => setKwPay(e.target.value)} className="input" />
                            <div className="save">
                              <AiFillCheckCircle cursor="pointer" size={16} onClick={postEditKwApi} />
                              <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditKwPay(false)} />
                            </div>
                          </div>
                        ) : (
                          <div className="text">
                            {kwPay}
                            <MdEdit color="black" className="edit-icon" onClick={() => setIsEditKwPay(true)} cursor="pointer" />
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text">
                        {kwPay}
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </>
          )}
          {/* Manager Override */}
          {values === "Manager" && (
            <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
              <div className="card-box">
                <div className="title">Manager Override:</div>
                <div className="field">
                  {isEditManagerOverride ? (
                    <div className="edit">
                      <input type="text" value={overRide} onChange={(e) => setOverRide(e.target.value)} className="input" />
                      <div className="save">
                        <AiFillCheckCircle cursor="pointer" size={16} onClick={postOverrideApi} />
                        <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditManagerOverride(false)} />
                      </div>
                    </div>
                  ) : (
                    <div className="text">
                      {overRide}
                      <MdEdit color="black" className="edit-icon" onClick={() => setIsEditManagerOverride(true)} cursor="pointer" />
                    </div>
                  )}
                </div>
              </div>
            </Col>
          )}
          {/* Setter Commission Tier, Closer Commission Tier */}
          {values !== "Setter" && (
            <>
              {/* Setter Commission Tier */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Setter Commission Tier:</div>
                  <div className="field">
                    {getUserPermissions('edit-user-redline-action') ? (
                      <Select value={postSetterCom} className="select" onChange={postSetterApi} style={{ minWidth: 177 }}>
                        {repCom.map((rep) => (
                          <Option key={`${rep._id}${Math.random()}`} value={rep._id}>{rep.name}</Option>
                        ))}
                      </Select>
                    ) : (
                      <div className="text">{repCom?.find((el) => String(el?._id) == data?.repCom)?.name}</div>
                    )}
                  </div>
                </div>
              </Col>
              {/* Closer Commission Tier */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Closer Commission Tier:</div>
                  <div className="field">
                    {getUserPermissions('edit-user-redline-action') ? (
                      <Select value={postRepCom} className="select" onChange={postRepApi} style={{ minWidth: 177 }}>
                        {repCom.map((rep) => (
                          <Option key={`${rep._id}${Math.random()}`} value={rep._id}>{rep.name}</Option>
                        ))}
                      </Select>
                    ) : (
                      <div className="text">{repCom?.find((el) => String(el?._id) == data?.repCom)?.name}</div>
                    )}
                  </div>
                </div>
              </Col>
            </>
          )}
          {/* Per setter Sit Amount */}
          {values === "Setter Manager" && (
            <>
              {/* Sit Pay Amount */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Per Sit Amount:</div>
                  <div className="field">
                    {isEditPerSetterAmount ? (
                      <div className="edit">
                        <input type="text" value={perSit} onChange={(e) => setPerSitAmount(e.target.value)} className="input" />
                        <div className="save">
                          <AiFillCheckCircle cursor="pointer" size={16} onClick={postEditPerSitApi} />
                          <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditPerSetterAmount(false)} />
                        </div>
                      </div>
                    ) : (
                      <div className="text">
                        {perSit}
                        <MdEdit color="black" className="edit-icon" onClick={() => setIsEditPerSetterAmount(true)} cursor="pointer" />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </>
          )}
          {/* Per Sit Amount */}
          {values === "Sit Manager" && (
            <>
              {/* Sit Pay Amount */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Per Sit Amount:</div>
                  <div className="field">
                    {isEditPerSitAmount ? (
                      <div className="edit">
                        <input type="number" value={perSit} onChange={(e) => setPerSitAmount(e.target.value)} className="input" />
                        <div className="save">
                          <AiFillCheckCircle cursor="pointer" size={16} onClick={postPerSitAmount} />
                          <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditPerSitAmount(false)} />
                        </div>
                      </div>
                    ) : (
                      <div className="text">
                        {perSit}
                        <MdEdit color="black" className="edit-icon" onClick={() => setIsEditPerSitAmount(true)} cursor="pointer" />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </>
          )}
          {/* Company Commission, Company Commission Amount */}
          {getUserPermissions("company-commission-view") && (
            <>
              {/* Company Commission */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Company Commission:</div>
                  <div className="field">
                    <Checkbox
                      checked={check}
                      name="companyCommission"
                      onChange={postCompanyCheckApi}
                    />
                  </div>
                </div>
              </Col>
              {/* Company Commission Amount */}
              <Col xs={24} sm={24} lg={24} xl={12} xxl={8}>
                <div className="card-box">
                  <div className="title">Company Commission Amount:</div>
                  <div className="field">
                    {isEditCompanyCommissionAmount ? (
                      <div className="edit">
                        <input type="text" value={companyAmount} onChange={(e) => setCompanyAmount(e.target.value)} className="input" disabled={showDisable} />
                        <div className="save">
                          <AiFillCheckCircle cursor="pointer" size={16} onClick={postCompanyAmountApi} />
                          <AiFillCloseCircle cursor="pointer" size={16} onClick={() => setIsEditCompanyCommissionAmount(false)} />
                        </div>
                      </div>
                    ) : (
                      <div className="text">
                        {companyAmount}
                        <MdEdit color="black" className="edit-icon" onClick={() => setIsEditCompanyCommissionAmount(true)} cursor="pointer" />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </>
          )}
        </Row>
      </div>
      <div className="bottom-container">
        {getUserPermissions("login-user-action") && (
          <Button
            title="Login"
            className="button"
            onClick={() => handleLoginAsUser(data?.email, data?.password)}
          />
        )}
        {getUserPermissions("user-reset-password-action") && (
          <Popconfirm
            title="Are you Sure you want to reset password?"
            onConfirm={postResetPassword}
          >
            <Button
              loading={isResetLoading}
              className="button"
              title="Reset Password"
            />
          </Popconfirm>
        )}
      </div>
    </UserinfoWrapper >
  );
};

export default UserInfo;
